import i18n from 'i18next'

export const getStringDuration = (sec: number): string => {
  const min = sec / 60
  if (min < 10) {
    return `${Math.round(min)} min`
  }
  if (min <= 60) {
    const minRound = Math.round(min / 5) * 5 // round to the nearest multiple of 5
    return minRound === 60 ? `1 ${i18n.t('hour')}` : `${minRound} min`
  }
  if (min > 60 && min < 120) {
    return `1 ${i18n.t('hour')} ${i18n.t('and')} ${
      Math.round((min - 60) / 5) * 5
    } min`
  }
  // more than 2 hours, round to the hour
  return i18n.t('{{ count }} hours', { count: Math.round(min / 60) })
}
